import React from 'react';
import styled, { css } from 'styled-components';
import { Label } from 'reactstrap';

const isChosenStyle = css`
  && {
    && {
      .inner {
        background: black;
      }
    }
  }
`;

export default styled(({ isChosen, ...rest }) => <Label {...rest} />)`
  position: relative;
  display: grid;
  justify-self: center;
  align-self: center;
  text-align: center;
  cursor: pointer;
  ${({ isChosen }) => isChosen && isChosenStyle}
`;
